export default __webpack_public_path__ + "static/media/am3.ada51d85.jpg";